<template>
    <b-modal id="show-modal" centered hide-footer no-close-on-backdrop size="xl">
        <template #modal-header>
            <h5 class="my-0">{{ $t("account-page-facility-payout.payout_date") }}: {{ formatDate(datum.arrival_date) }}
            </h5>
            <button type="button" class="close" @click="$bvModal.hide('show-modal')">
                <span aria-hidden="true">&times;</span>
            </button>
        </template>
        <div class="row">
            <div class="col-12">
                <label class="h5">{{ $t("account-page-facility-payout.transactions") }}</label>
                <div class="table-responsive table-bordered visitors-table">
                    <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
                        <thead>
                            <tr>
                                <th>{{ $t("account-page-facility-payout.checkin_date") }}</th>
                                <th>{{ $t("account-page-facility-payout.checkout_date") }}</th>
                                <th>{{ $t("account-page-facility-payout.settlement_date") }}</th>
                                <th>{{ $t("account-page-facility-payout.captured_date") }}</th>
                                <th>{{ $t("account-page-facility-payout.reservation") }}</th>
                                <th>{{ $t("account-page-facility-payout.amount") }} JPY</th>
                                <th>{{ $t("account-page-facility-payout.fee") }} JPY</th>
                                <th>{{ $t("account-page-facility-payout.net") }} JPY</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(value, key) in data" :key="key">
                                <td>{{ formatDate(value.checkin_date) }}</td>
                                <td>{{ formatDate(value.checkout_date) }}</td>
                                <td>{{ formatDate(value.authorized_date) }}</td>
                                <td>{{ formatDate(value.captured_date) }}</td>
                                <td>{{ value.pms_reservation_no ? value.pms_reservation_no : "--" }}</td>
                                <td>{{ formatAmount(value.amount) }}</td>
                                <td>{{ formatAmount(value.fee) }}</td>
                                <td>{{ formatAmount(value.net) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import formatters from '@/mixins/formatters.js';

export default {
    name: "StripeShow",
    data() {
        return {
            datum: {},
            data: [],
        };
    },
    methods: {
        async view(datum) {
            this.data = await this.$lionheart.get("v2/payment/pms/payout/transactions/" + datum.id, { params: { facility_id: datum.facility_id } }).then((success) => success.data.data);

            this.datum = datum;
            this.$bvModal.show("show-modal");
        },
    },
    mixins: [formatters],
};
</script>

<style scoped></style>
